<template>
  <div>
    <SettingsMain/>
  </div>
</template>

<script>
import SettingsMain from '@/components/SettingsMain'

export default {
  components: {
    SettingsMain
  }
}
</script>
